import React from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import Form from '../../components/Forms/Form/Form';
import {Utils,NavigateTo} from './../../Utils';

import './Profile.css'; 
import { redirect } from 'react-router-dom';

class Profile extends React.Component {
  
  settings = {};

  constructor(props) {
    super(props);
    
    this.state = {
      show: false,
      hiding: false,
      redirect: false,
      fcm_token: ''
    };
  }

  /**
   * Form hívja meg ha sikeresen lefutott a handle_submit()
   * ha nincs szükség erre a fv.-re akkor lehet törölni
   */
  on_submit_success(params = {formData: {}, result: {}}) {
    this.hide();
  }

  show() {
    window.AppRef.current.get_settings().then((resp)=>{
        this.settings = resp.settings;
        const fcm_token = localStorage.getItem('fcm_token_ready') || ''; 
  
        this.setState({show: true, fcm_token: fcm_token}, () => {
          window.AppRef.current.handle_keyboard_events();
        });
      });
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  /**
   * alárendelt komponensek megnyitása (Számlázási cím, Szállítási cím, Fizetési mód)
   */
  handle_link_click(e, target) {
    if (typeof window.modals[target + 'Ref'].current !== 'undefined')
    {
      window.modals[target + 'Ref'].current.toggle();
    }
  }

  handle_delete_reg_click(e) {
    e.preventDefault();

    window.AppRef.current.set_dialog_message(i18n.t('profileDeleteRegistrationConfirm'), {
      cancel: true,
      callback: () => 
      {
        Utils.get_server_data(
          '', 
          {ajax_event: 'delete_registration', APICACHE: 'false'}, 
          {ajax_event: 'delete_registration', formData: JSON.stringify({})}
        )
          .then((res) => {
            if (res.success == 1)
            {
              window.AppRef.current.logout();
            }
            else {
              window.AppRef.current.set_dialog_message(i18n.t('profileDeleteRegistrationFail'));
            }
          });        
      }
    });
  }

  handle_logout_click() {
    window.AppRef.current.logout();
  }

  render() {
    const { show, hiding, fcm_token } = this.state;

    if (this.state.redirect===true){return <NavigateTo toURL='/'></NavigateTo>}

    if (!show) return '';

    return <div className={`container floating_container page_checkout page_profile ${hiding ? 'out' : ''}`}>
          <div className="content">
            
            <PageHeader parent_ref={this} no_close title={i18n.t('profileTitle')} />

            <div className='container_inner'>

              <Form name="profile" submit_text={i18n.t('save')} parent={this} />

              {this.settings.settings.display_fcm_token ? 
                <div className='row'>
                  <div className="field text ">
                    <label className="field_label" style={{marginBottom: "15px", display: "inline-block"}}>FCM token:</label>
                    <input type="text" value={fcm_token} />
                  </div>
                </div>
              : ''}

              <div className='links'>
                <div className='link' onClick={(e) => this.handle_link_click(e, 'ProfileBillAddress')}>{i18n.t('profileBillAddress')}<ReactSVG src="assets/images/arrow_down.svg" /></div>
                <div className='link' onClick={(e) => this.handle_link_click(e, 'ProfileDeliveryAddresses')}>{i18n.t('profileDeliveryAddress')}<ReactSVG src="assets/images/arrow_down.svg"/></div>
               
                <div className='link red' onClick={(e) => this.handle_delete_reg_click(e)}>{i18n.t('profileDeleteRegistration')}</div>
                {/*<div className='link' onClick={(e) => this.handle_link_click(e, 'ProfilePaymentMethod')}>{i18n.t('profilePaymentMethod')}<ReactSVG src="assets/images/arrow_down.svg" /></div>*/}
                <div className='link' onClick={() => this.handle_logout_click()}>{i18n.t('profileLogout')}</div>
              </div> 
            
            </div>
          </div>
      </div>;
  }
}

export default Profile;